import { ApprovalI } from "../approvals/approvalsTypes";

export const realTimeData = {
  ADD_STACK    : "@REALTIME/ADD_STACK",
  UPDATE_STACK : "@REALTIME/UPDATE_STACK",
  REMOVE_STACK : "@REALTIME/REMOVE_STACK",
  RESET_STACK  : "@REALTIME/RESET_STACK",
};

export interface RealTimeDataReducer {
  approvalsStack: Array<ApprovalI>;
  section?: "queue" | "history";
}

export interface AddStackI {
  type: string;
  payload: {
    approval: ApprovalI;
  };
}

export interface UpdateStackI {
  type: string;
  payload: {
    approval: ApprovalI;
  };
}

export interface RemoveStackI {
  type: string;
  payload: {
    approval_id: number;
  };
}

export interface ResetStackI {
  type: string;
  payload: "queue" | "history";
}

export type realTimeDataTypes = AddStackI | UpdateStackI | RemoveStackI | ResetStackI
